import cn from "@utils/helpers/cn";
import sx from "@utils/helpers/sx";

const CLASS_NAMES = cn(`
  duration-250
  relative
  z-50
  mx-0
  block
  max-w-full
  scroll-m-4
  break-inside-avoid
  rounded-2xl
  border
  border-solid
  shadow-xl
  shadow-black/30
  transition-all
  ease-in-out
  tap-highlight-transparent
  overflow-hidden

  border-card-default-border
  bg-card-default-bg
  text-card-default-text
`);

const HEADER_CLASS_NAMES = cn(`
  relative
  flex
  h-48
  w-full
  items-end
  justify-start
  overflow-hidden
  bg-cover
  bg-center
  text-center
  font-serif
  text-[0.5rem]
  capitalize
  tracking-[1px]
`);

const CONTENT_WRAPPER_CLASS_NAMES = cn(`
  p-5
`);

export default function Card(props) {
  const {
    className,
    contentClassName,
    contentWrapperClassName,
    style,
    content,
    children,

    isHoverable,
    headerImageUrl,
    ...otherProps
  } = props;

  const contentWrapperClasses = cn(CONTENT_WRAPPER_CLASS_NAMES, contentWrapperClassName);

  const classNames = cn(CLASS_NAMES, className, {
    "hover:text-card-hover-text": isHoverable,
    "hover:bg-card-hover-bg": isHoverable,
    "hover:border-card-hover-border": isHoverable,
  });

  /**************************************************************************************************/

  if (!content && !children) return null;

  return (
    <div
      className={classNames}
      style={sx({
        backgroundImage: "var(--background-image-noise-2)",
        backgroundSize: "40rem",
        ...style,
      })}
      {...otherProps}
    >
      {headerImageUrl && (
        <div
          className={HEADER_CLASS_NAMES}
          style={{
            backgroundImage: `url(${headerImageUrl})`,
            textShadow: "1px 1px 7px black",
          }}
        />
      )}

      <div className={contentWrapperClasses}>
        {content ? (
          <div
            className={contentClassName}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : children}
      </div>
    </div>
  );
}
